// @ts-check

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

export function ClientInfoComponent({ headingText, displayValue }) {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
        <small>
          <b>{headingText}</b>
        </small>
      </Typography>
      <List className={classes.root}>
        <ListItem>
          <ListItemText primary={`${displayValue}`} secondary={null}></ListItemText>
        </ListItem>
      </List>
    </div>
  );
}
